import Close from "@assets/header/close-t.svg?react";
import CloseDark from "@assets/header/close-t-dark.svg?react";
import MenuImg from "@assets/header/menu.svg?react";
import MenuDark from "@assets/header/menu-dark.svg?react";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import type { ReactElement } from "react";

interface MenuButtonProps {
  theme: ThemeEnum;
  menuShow: boolean;
  onClick: () => void;
}

export default function MenuButton({
  theme,
  menuShow,
  onClick,
}: MenuButtonProps): ReactElement {
  return (
    <button className="block lg:hidden" onClick={onClick}>
      {menuShow ? (
        theme === ThemeEnum.dark ? (
          <CloseDark className="m-[8px] size-[24px]" />
        ) : (
          <Close className="m-[8px] size-[24px]" />
        )
      ) : theme === ThemeEnum.dark ? (
        <MenuDark className="m-[8px] size-[24px]" />
      ) : (
        <MenuImg className="m-[8px] size-[24px]" />
      )}
    </button>
  );
}
